import { Injectable } from '@angular/core';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { GetImageUrlService } from 'ZalamoLibrary/src/lib/core/image/image-loader/get-image-url.service';
import { select, Store } from '@ngrx/store';
import { SinglePhotoProductOptionsComponent } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/single-photo-product-options/single-photo-product-options.component';
import {
  selectGetPrintsPricingForPhoto,
  selectShoppingCartContext,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import { first, map, takeUntil } from 'rxjs/operators';
import { PublicSessionForDisplay } from '../graphql';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { routerGetLastChild } from 'ZalamoLibrary/src/lib/core/RouterHelpers';
import { PublicSessionScreenProtectionService } from './public-session-screen-protection.service';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));
  context$ = this.store.pipe(select(selectShoppingCartContext));

  constructor(
    private screenObserver: BreakpointObserver,
    private dialog: ZalamoDialogService,
    private imageLoader: GetImageUrlService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private publicSessionScreenProtectionService: PublicSessionScreenProtectionService,
  ) {}

  openCartOptions(
    photoId,
    photoGroupId,
    publicSession: PublicSessionForDisplay,
  ) {
    let phone = false;
    this.isPhonePortrait$.pipe(first()).subscribe((x) => (phone = x));
    const ref = phone
      ? this.dialog.openFull(SinglePhotoProductOptionsComponent, {
          isBare: true,
        })
      : this.dialog.openRight(SinglePhotoProductOptionsComponent);
    this.publicSessionScreenProtectionService.suspendWhileDialogOpen(ref);
    console.log('CART OPTIONS' + '');
    ref.componentInstance.sellLookBookWallDecor =
      publicSession.lookBookEnabled &&
      publicSession.lookBookConfig?.sellWallDecor;
    ref.componentInstance.sellZalamoCalendar = publicSession.sellCalendar;
    ref.componentInstance.calendarPrices = publicSession.calendarPrices;
    ref.componentInstance.sellZalamoMagnet = publicSession.sellMagnet;
    ref.componentInstance.magnetPrices = publicSession.magnetPrices;
    ref.componentInstance.sellLookBookTambour =
      publicSession.lookBookEnabled &&
      publicSession.lookBookConfig?.sellTambour;
    ref.componentInstance.sellPrintFrames =
      publicSession.lookBookEnabled &&
      publicSession.lookBookConfig?.sellPrintFrames;
    ref.componentInstance.disablePersonalizationOnSinglePhotoWallDecor =
      publicSession.lookBookConfig?.wallDecorConfig.disablePersonalizationOnSinglePhoto;
    ref.componentInstance.disablePersonalizationOnSinglePhotoTambour =
      publicSession.lookBookConfig?.tambourConfig.disablePersonalizationOnSinglePhoto;
    this.imageLoader
      .transform(
        photoId,
        photoGroupId,
        'anyone',
        'public_session',
        publicSession.publicSessionId,
        2048,
      )
      .toPromise()
      .then((url) => {
        console.log(url);
        ref.componentInstance.cd.detectChanges();
      });
    ref.componentInstance.photoId = photoId;
    this.store
      .select(selectGetPrintsPricingForPhoto, {
        photoId,
      })
      .pipe(first())
      .subscribe((pricing) => {
        if (pricing?.individualSellSettings) {
          if (pricing.sellPrints) {
            ref.componentInstance.addPrintFileToBasketIfNotAlreadyBought =
              pricing.priceToAddToFirstPrint.addPrintFileToBasketIfNotAlreadyBought;
            ref.componentInstance.addToFirstPrintPrice =
              pricing.priceToAddToFirstPrint.addToFirstPrintPrice;
            if (pricing.customPrintsPricing) {
              ref.componentInstance.onlyOneGroup = photoGroupId;
              ref.componentInstance.printsPricing = pricing.prints.map(
                ({
                  printFormatId,
                  printPaperId,
                  price,
                  stepPricing,
                  stepPricingEnabled,
                }) => ({
                  printFormatId,
                  printPaperId,
                  price,
                  stepPricing,
                  stepPricingEnabled,
                }),
              );
            } else {
              ref.componentInstance.printsPricing =
                publicSession.printsPricing?.list.map(
                  ({
                    printFormatId,
                    printPaperId,
                    price,
                    stepPricing,
                    stepPricingEnabled,
                  }) => ({
                    printFormatId,
                    printPaperId,
                    price,
                    stepPricing,
                    stepPricingEnabled,
                  }),
                );
            }
          }
          if (pricing.sellFiles) {
            if (pricing.customFilesPricing) {
              ref.componentInstance.filesPricing = pricing.files;
            } else {
              ref.componentInstance.filesPricing = publicSession.filePricing;
            }
          }
        } else {
          if (publicSession.sellFiles) {
            ref.componentInstance.filesPricing = publicSession.filePricing;
          }
          if (publicSession.sellPrints) {
            ref.componentInstance.addPrintFileToBasketIfNotAlreadyBought =
              publicSession.addPrintFileToBasketIfNotAlreadyBought;
            ref.componentInstance.addToFirstPrintPrice =
              publicSession.addToFirstPrintPrice;
            ref.componentInstance.printsPricing =
              publicSession.printsPricing?.list.map(
                ({
                  printFormatId,
                  printPaperId,
                  price,
                  stepPricing,
                  stepPricingEnabled,
                }) => ({
                  printFormatId,
                  printPaperId,
                  price,
                  stepPricing,
                  stepPricingEnabled,
                }),
              );
          }
        }
        console.log(11111111, pricing.disableLookBook);
        if (pricing.disableLookBook) {
          ref.componentInstance.sellPrintFrames = false;
        }
        if (pricing.disableZalamoPrint) {
          ref.componentInstance.sellZalamoCalendar = false;
          ref.componentInstance.sellZalamoMagnet = false;
        }
      });
    this.context$.pipe(first()).subscribe(({ context, contextId }) => {
      // @ts-ignore
      ref.componentInstance.context = context;
      ref.componentInstance.contextId = contextId;
    });
    ref.componentInstance.closeDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
      });
    ref.componentInstance.closeAllDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
      });
    ref.componentInstance.goToPackageMenu
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
        ref
          .afterClosed()
          .pipe(first())
          .subscribe(() => {
            this.router.navigate(['../menuPackagesAndProducts'], {
              relativeTo: routerGetLastChild(this.route),
              queryParamsHandling: 'preserve',
            });
          });
      });
    ref.componentInstance.cd.detectChanges();
    return ref;
  }
}
